import {
  CreateExperienceProductDto,
  ExperienceProductVariantDto,
  ExperienceVariationPricesDto,
} from "@intelligems/ig-types";
import { AgProduct } from "@src/store/slices/agProducts/types";
import { getPriceFromExperienceProduct } from "@src/store/slices/agProducts/util/getPriceFromExperienceProduct";

export function experienceProductVariantToAgProduct(
  product: CreateExperienceProductDto,
  variant: ExperienceProductVariantDto
) {
  const agProduct: AgProduct = {
    productId: product.id,
    productTitle: product.title ?? "",
    productImage: product.image || null,
    handle: product.handle,
    variantId: variant.id,
    variantTitle: variant.title,
    variantPrice: "",
    requiresSellingPlan: false,
    variationPrices: (variant.variationPrices || [])
      .map((group: ExperienceVariationPricesDto) => {
        const price = getPriceFromExperienceProduct(group.price);
        const compareAtPrice = getPriceFromExperienceProduct(
          group.compareAtPrice
        );
        return {
          name: group.name,
          id: variant.id,
          variationId: group.variationId,
          price,
          ogPrice: group.price,
          compareAtPrice,
          ogComparePrice: group.compareAtPrice,
        };
      })
      .reduce((k, v) => ({ ...k, [v.variationId ?? ""]: v }), {}),
  };
  return agProduct;
}
